// extracted by mini-css-extract-plugin
export default {"suppressed":"styles_suppressed__vMUbP"};